import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-services-list',
  templateUrl: './services-list.component.html',
  styleUrls: ['./services-list.component.scss']
})
export class ServicesListComponent implements OnInit {
  @Input() contractInfo: any;
  @Input() providerInfo: any;
  @Input() customerInfo: any;
  @Input() status: any;
  @Input() goods: any;
  @Input() id: any;
  constructor(public router: Router) { }

  ngOnInit(): void {
  }
}
